import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  HintIdMetadata,
  HintSponsorDetail,
  SponsorRelationshipToUser,
  SponsorshipDetail,
} from '../../react/api/model/sponsorship';
import { UUID } from '../../react/types';

interface UpdateSponsorshipInfoRequest {
  sponsorHintId: string;
  sponsorRelationshipToUser: SponsorRelationshipToUser;
}

interface UpdateSponsorshipEligibility {
  ineligible: boolean;
}

export type HintSponsorMetadataResponse = {
  successfulMetadata: HintSponsorDetail[];
  unsuccessfulMetadata: HintIdMetadata[];
};

@Injectable({
  providedIn: 'root',
})
export class SponsorshipService {
  constructor(private httpClient: HttpClient) {}

  public getPatientSponsorshipInfo(patientUserId: UUID): Promise<SponsorshipDetail> {
    const url = `${environment.niceServiceUrl}/v2/users/${patientUserId}/sponsorships?includeLegacySubmissions=true`;
    return this.httpClient.get<SponsorshipDetail>(url).toPromise();
  }

  public getSponsorHintMetadata(hintId: string): Promise<HintSponsorMetadataResponse> {
    const url = `${environment.niceServiceUrl}/v1/sponsorships/metadata`;
    return this.httpClient
      .get<HintSponsorMetadataResponse>(url, {
        params: new HttpParams().set('hintId', hintId),
      })
      .toPromise();
  }

  public updatePatientSponsorshipInfo(
    patientUserId: UUID,
    hintId: string,
    sponsorRelationshipToUser: SponsorRelationshipToUser
  ): Promise<void> {
    const url = `${environment.niceServiceUrl}/v1/users/${patientUserId}/sponsorships`;

    const request: UpdateSponsorshipInfoRequest = {
      sponsorHintId: hintId,
      sponsorRelationshipToUser: sponsorRelationshipToUser,
    };

    return this.httpClient.post<void>(url, request).toPromise();
  }

  public deleteSponsorshipInfo(patientUserId: UUID, sponsorshipId: number): Promise<void> {
    const url = `${environment.niceServiceUrl}/v1/users/${patientUserId}/sponsorships/${sponsorshipId}`;

    return this.httpClient.delete<void>(url).toPromise();
  }

  public markPatientSponsorshipEligibility(patientUserId: UUID, ineligible: boolean): Promise<void> {
    const url = `${environment.niceServiceUrl}/v1/users/${patientUserId}/sponsorships/eligibility`;

    const request: UpdateSponsorshipEligibility = {
      ineligible: ineligible,
    };

    return this.httpClient.post<void>(url, request).toPromise();
  }
}
